import { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './richtext.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export default function RichTextEditor({ value, onChange, placeholder = '', disabled }: RichTextEditorProps) {
  const quillRef = useRef<any>(null);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    editor.on('text-change', () => {
      const html = editor.root.innerHTML;

      const fixed = html.replace(/href="(?!https?:\/\/)([^"]+)"/g, 'href="https://$1"');

      if (fixed !== html) {
        editor.root.innerHTML = fixed;
      }
    });
  }, []);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code'],
      ['link', 'image'],
      ['clean'],
    ],
  };

  return (
    <>
      <div className={`border border-gray-200 rounded-xl ${disabled ? 'bg-gray-100 opacity-70' : ''}`}>
        <ReactQuill
          placeholder={placeholder}
          ref={quillRef}
          value={value}
          onChange={onChange}
          modules={disabled ? { toolbar: false } : modules}
          theme="snow"
          className="custom-quill"
          readOnly={disabled}
        />
      </div>
    </>
  );
}
